const configure = {
  // apiUrl: "https://endemoapi.zithas.com/api",
  // imgUrl: "https://edemoapi.zithas.com/application/public",
  // appUrl: "/introducer-portal",
  // api: "https://edemoapi.zithas.com/api",

  apiUrl: "https://napi.zithas.com/api",
  imgUrl: "https://mars.zithas.com/application/public",
  appUrl: "",
  api: "https://api.zithas.com/api",

  proxy: "https://cors-anywhere.herokuapp.com/",
  marsimg: "https://mars.ztpl.net/application/public",
};

export default configure;
